module.exports = __webpack_public_path__ + "static/media/ProviderReferralImaging.9ab10f89.txt";